import React, { useContext, useEffect, useState } from 'react'
import { ApiGetCallAuthKey, ApiGetCDNData, ApiPostCallAuthKey } from '../../JS/Connector';
import { HideLoder, ShowLoder } from '../../JS/Common';
import { CheckValidation } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import Popup from '../../Components/Popup';
import ImagesPopup from '../../Components/ImagesPopup';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export function TicketDetails() {
  const {staff_member, manager_user, student_no, third_party_page_logo} = useConfig();
  const [schoolname, setschoolname] = useState("");
  const [schoolID, setschoolID] = useState("");
  const [Comments, setComments] = useState([]);
  const [TicketDetails, setTicketDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const [Alerts, setAlerts] = useState("");
  const pathname = window.location.pathname;
  const pathArray = pathname.split('/');
  const ticketid = pathArray[2];
  const schoolnumber = pathArray[3];
  const ticketnumber = pathArray[4];
  const guid = pathArray[5];
  const [PreviewImg, SetPreviewImg] = useState('');
  const [ShowCommentBox, setShowCommentBox] = useState(null);
  const [allData, setAllData] = useState({
    Comment: "",
    Document: null,
    Filename: "",
  });
  const [PopupImage, SetPopupImage] = useState(null);
  const [PopupVideo, SetPopupVideo] = useState(null);
  const [showImagesModal, setShowImagesModal] = useState({
    show: false,
    activeIndex: 0,
    zoomInOut: false,
  });

  useEffect(() => {
    if (TicketDetails.img) {
      ApiGetCDNData("/" + TicketDetails.img, schoolnumber, TicketDetails?.school_id).then((result) => {
        var url = URL.createObjectURL(result)
        SetPopupImage(url)
      });
    }
    if (TicketDetails.video_path) {
      ApiGetCDNData("/" + TicketDetails.video_path, schoolnumber, TicketDetails?.school_id).then((result) => {
        var url = URL.createObjectURL(result)
        SetPopupVideo(url)
      });
    }
  }, [TicketDetails.img, TicketDetails.video_path, TicketDetails]);
  useEffect(() => {
    setLoading(true);
    const apiGuid = guid && guid.trim() !== "" ? guid : null;
    ApiGetCallAuthKey(`/support-tickets/external-data?uuid=${ticketid}&schoolNumber=${schoolnumber}&ticketNumber=${ticketnumber}&ticketGuid=${apiGuid}&type=1`).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        if (responseRs.status == "error") {
          setShowCommentBox(1);
          setAlerts(<AlertsComp msg={"Invalid ticket url"} show={true} variant={"danger"} />);
          setTimeout(() => {
            setAlerts(<AlertsComp show={false} />);
          }, 2000)
          return
        }
        ApiGetCallAuthKey(`/schools/by-number?schoolNumber=${schoolnumber}`).then((result) => {
          if (result == undefined || result == "") {
            alert("Something went wrong");
          } else {
            const responseRs = JSON.parse(result);
            setschoolname(responseRs.msg.name);
            setschoolID(responseRs.msg.id);
          }
        });
        GetComment();
        setShowCommentBox(responseRs.commentflag == 1 ? 1 : 2);
      }
    });

  }, []);


  async function GetComment() {
    await ApiGetCallAuthKey(`/support-tickets/comments?ticketId=${ticketid}`).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        setLoading(false);
        if (responseRs.status == "success") {
          if (responseRs.support_ticket_details.img != null) {
            ApiGetCDNData("/" + responseRs.support_ticket_details.img, schoolnumber, responseRs?.support_ticket_details?.school_id).then((result) => {
              var url = URL.createObjectURL(result)
              SetPreviewImg(url)
            });
          }
          setComments(responseRs.msg);
          setTicketDetails(responseRs.support_ticket_details);
        }
      }
    });
  }

  function handlePdfFileUpload(e) {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = function (event) {
      const base64String = event.target.result;
      const base64Value = base64String.split(";base64,").pop();
      setAllData({ ...allData, Document: base64Value, Filename: file.name, Flag: 1 });
    };

    reader.readAsDataURL(file);
  };

  async function SaveSupportTicketCall() {
    var isFormValid = CheckValidation({ formID: 'SupportTicketForm' });
    if (!isFormValid) return;
    setLoading(true);
    var raw = JSON.stringify({
      schoolId: schoolID,
      ticketNumber: ticketnumber,
      userEmail: null,
      comment: allData.Comment,
      assignStaffMemberId: TicketDetails.AssignedTo || null,
      flag: 2,
      document: allData.Document,
      commentFlag: ShowCommentBox
    });
    await ApiPostCallAuthKey("/support-tickets/add-comment", raw).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        setLoading(false);
        if (result == "success") {
          setAllData({ ...allData, Comment: "", Document: null, Filename: "" });
          setAlerts(<AlertsComp show={true} variant="success" msg={"Comment Successfully."} />);
          setTimeout(() => {
            setAlerts(<AlertsComp show={false} />)
            window.location.reload();
          }, 1500);
        }
        else {
          setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
          setTimeout(() => {
            setAlerts(<AlertsComp show={false} />);
          }, 2000);
        }
      }
    });
  }
  function getImageUrl(imgurl) {
    ApiGetCDNData("/" + imgurl, schoolnumber, TicketDetails?.school_id).then((result) => {
      try {
        const url = URL.createObjectURL(result);
        if (url) SetPreviewImg(url);
      } catch (err) {
        log.error(err);
      }
    });
  }
  return (
    <div>
      {Alerts}
      {loading ? <ShowLoder /> : <HideLoder />}
      <div className="row">
        <div className="col-md-10 offset-md-1">
          <div className={window.innerWidth >= 767 ? 'm-3 px-1' : ''}>
            <div className={window.innerWidth >= 767 ? 'GridBox p-4 m-auto mx-5' : 'GridBox p-4 m-auto'}>
              <div className="col-12 text-center pb-4">
                {third_party_page_logo ?
                  <img src={third_party_page_logo} className="img-fluid" alt="Logo" />
                  :
                  <img src="/images/LoginLogo.png" className="img-fluid" alt="Logo" />
                }
              </div>
              <div className='Header mt-2 text-center '>
                <h5 className="mb-0">
                  <>{TicketDetails.type == 1 ? "Technology" : "Maintenance "} Support Ticket Comment(s) of <span className="schoolColorStatus">{schoolname}</span></>
                </h5>
                <img src='/images/supportTicketLine.svg' className='img-fluid ' />
                <div className='row mt-4'>
                  <div className='col-lg-5'>
                    <div className='greyBox'>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Ticket # :  </div>
                        <div className="col-md-8 text-start"> {TicketDetails.support_ticket_num || '-'}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Role :  </div>
                        <div className="col-md-8 text-start"> {TicketDetails.role == 2 ? staff_member : manager_user}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Name : </div>
                        <div className="col-md-8 text-start"> {TicketDetails.name || '-'}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4  text-start fw-600 supportticket-fontcolor">Email : </div>
                        <div className="col-md-8 text-start"> {TicketDetails.email || '-'}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Building : </div>
                        <div className="col-md-8 text-start text-break"> {TicketDetails.other_building_name ? TicketDetails.other_building_name : TicketDetails?.building?.name}</div>
                      </div>
                      {TicketDetails.role == 2 && (
                        <div className="p-1 pt-2 pe-0 row">
                          <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Room No. : </div>
                          <div className="col-md-8 text-start"> {TicketDetails.room_name ? TicketDetails.room_name : TicketDetails?.room ? TicketDetails?.room?.name : '-'}</div>
                        </div>
                      )}
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">{student_no} : </div>
                        <div className="col-md-8 text-start"> {TicketDetails.student_num || '-'}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Issue Type :  </div>
                        <div className="col-md-8 text-start">  {TicketDetails.issue_type || '-'}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Ticket Subject :  </div>
                        <div className="col-md-8 text-start" style={{ wordWrap: "break-word" }}>  {TicketDetails.title || '-'}</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        {TicketDetails.description != null ?
                          <>
                            <div className="text-start fw-600 supportticket-fontcolor">Ticket Description:  </div>
                            <div className="text-start">  {TicketDetails.description || '-'}</div>
                          </>
                          :
                          <>
                            <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Ticket Description:  </div>
                            <div className="col-md-8 text-start">  {TicketDetails.description || '-'}</div>
                          </>
                        }

                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Attached Image :  </div>
                        <div className="col-md-8 text-start">   {PopupImage ?
                          <img className='w-100 ps-2 cursor-pointer'
                            title='Preview Image' alt="" src={PopupImage} height="70px" onClick={(e) => {
                              SetPreviewImg(PopupImage);
                              setShowImagesModal({ ...showImagesModal, show: true, activeIndex: 0 })
                            }}
                          />
                          :
                          <>-</>
                        }</div>
                      </div>
                      <div className="p-1 pt-2 pe-0 row">
                        <div className="col-md-4 text-start fw-600 supportticket-fontcolor">Attached Video:</div>
                        <div className="col-md-8 text-start cursor-pointer">
                          {PopupVideo ? (
                            <iframe
                              width="200"
                              height="100"
                              src={PopupVideo}
                              frameborder="0"
                              allowfullscreen

                            ></iframe>
                          ) : (
                            <>-</>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className='col-lg-7'>
                    {Comments.length != 0 ?
                      Comments.map((item, i) => {
                        const user = item.user;
                        return (
                          <div className='boxshaowstyle-forComments mb-3'>
                            <div className='row p-3 align-items-center'>
                              <div className="col-md-1 text-center ">
                                <img src="/images/ProfileIcon.svg" className="img-fluid" />
                              </div>
                              <div className="col-md-11 ">
                                <div className='chatheading text-start fw-600'>{user?.charAt(0)?.toUpperCase() + user?.slice(1)}</div>
                                <div className='chatheadingsubtitle text-start mt-1'>{item.dDate} at {item.time}</div>
                              </div>
                              <div className='col-md-11 offset-md-1 pt-2 chatheading text-start chatcontent'> {item.comment}  </div>
                              {item.img != null && (
                                <div className='text-start offset-md-1 pt-3'>
                                  <img src="/images/PicturePreview.svg" className="img-fluid boxshaowstyle cursor-pointer"
                                    onClick={(e) => {
                                      getImageUrl(item.img);
                                      setShowImagesModal({ ...showImagesModal, show: true, activeIndex: 0 })
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })
                      :
                      <div className="col-12 text-center boxshaowstyle p-3 mb-3">
                        No Comments Found
                      </div>
                    }
                    {/* add Comments */}
                    {ShowCommentBox == 2 && (
                      <div id='SupportTicketForm' className="parent addcomments-box-style">
                        <div className='row p-2 align-items-center'>
                          <div className="col-md-1 text-center ">
                            <img src="/images/ProfileIcon.svg" className="img-fluid" />
                          </div>
                          <div className="col-md-11 ">
                            <textarea rows={1} required className="comment-textarea col-12" name="comment"
                              placeholder='Write a comment here' value={allData.Comment}
                              onChange={(e) => setAllData({ ...allData, Comment: e.target.value })}
                            ></textarea>
                            <span className="form-text invalid-feedback text-start">
                              *required
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12 text-end pb-3 px-4">
                          {allData.Filename && <label className="pe-4 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)' }}>{allData.Filename} </label>}
                          <input
                            type="file"
                            id="UploadFileId"
                            name="myFile"
                            accept=".jpg,.png,.jpeg"
                            style={{ display: 'none' }} // Hide the file input initially
                            onChange={(e) => handlePdfFileUpload(e)}
                          />
                          <FontAwesomeIcon icon={faPaperclip} className='cursor-pointer' title='Attach Image or Screenshot' onClick={() => document.getElementById('UploadFileId').click()} />
                          <button className="SaveBtn mt-2 ms-4 px-4" onClick={(e) => SaveSupportTicketCall(e)}>Send</button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup isshow={lgShow} size={"md"} title={"Preview Image"}
        closePopup={(e) => { setLgShow(false); SetPreviewImg('') }}
        modalBody={<img src={PreviewImg} style={{ maxHeight: '600px', maxWidth: '100%' }} />}
        visibleSaveBtn={false} />
      <ImagesPopup
        AllImages={PreviewImg ? [PreviewImg] : [PopupImage]}
        isShow={showImagesModal.show}
        closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false })}
        title={"Preview Images"}
        size={"xl"}
        activeIndex={showImagesModal.activeIndex}
        handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
        zoomInOut={showImagesModal.zoomInOut}
        handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
      />

    </div >
  )
}
